import React, { useContext } from 'react';
import { GameContext } from '../../core/context/game.context';
import './ProgressButton.styles.scss';

export default React.memo(function ProgressButton({
  text,
  endText,
  timeout,
  onClickHandler,
  paused,
  state,
}: {
  text: string;
  endText?: string;
  timeout: number;
  onClickHandler: () => void;
  paused?: boolean;
  state: 'ok' | 'ko';
}) {
  const [toExpiredState, setToExpiredState] = React.useState(false);
  const intRef = React.useRef<number>();
  const gameCtx = useContext(GameContext);
  const theme = gameCtx.getTheme();

  React.useEffect(() => {
    if (paused) {
      return () => {
        window.clearTimeout(intRef.current);
      };
    }
    intRef.current = window.setTimeout(() => {
      setToExpiredState(true);
    }, timeout * 1000);
    return () => {
      window.clearTimeout(intRef.current);
    };
  }, [paused, timeout]);

  function _onClickHandler() {
    if (toExpiredState === true) {
      onClickHandler();
    }
  }

  return (
    <section className="ProgressButtonComponent">
      <div className="button basicButton" onClick={_onClickHandler}>
        <div
          className={'progressBar' + (paused ? ' paused' : '')}
          style={{ animationDuration: timeout + 's', backgroundColor: theme.main[0] }}
        ></div>
        <div className="text" style={{ color: state === 'ok' ? theme.main[2] : theme.variants[3][0] }}>
          {toExpiredState === true ? endText : text}
        </div>
      </div>
    </section>
  );
});
